document.addEventListener("DOMContentLoaded", function() {
    const productShells = document.querySelectorAll(".products-shell");

    for (let i = 0; i < productShells.length; i++) {
        const arrows = productShells[i].querySelectorAll(".arrow");
        let index = 0;
        for (let j = 0; j < arrows.length; j++) {
            arrows[j].addEventListener("click", function() {
                const productShell = this.parentElement;
                const productOuter = productShell.querySelector(".products-outer");
                
                const productColumns = productOuter.querySelectorAll(".product-column");
                const scrollWidth = productOuter.scrollWidth / productColumns.length;

                if (this.classList.contains("left-arrow")) {
                    productOuter.scrollLeft -= scrollWidth;
                    index--;
                    if (index < 0) {
                        index = 0;
                    }
                }
                else {
                    index++;
                    if (window.innerWidth > 850) {
                        if (index > productColumns.length - 5) {
                            index = productColumns.length - 5;
                        }
                        else {
                            productOuter.scrollLeft += scrollWidth;
                        }
                    }
                    else {
                        if (index > productColumns.length - 3) {
                            index = productColumns.length - 3;
                        }
                        else {
                            productOuter.scrollLeft += scrollWidth;
                        }
                    }
                }

                const leftArrow = productShell.querySelector(".left-arrow");
                const rightArrow = productShell.querySelector(".right-arrow");

                if (index > 0) {
                    leftArrow.classList.remove("inactive");

                    if (index == productColumns.length - 3) {
                        rightArrow.classList.add("inactive");
                    }
                    else {
                        rightArrow.classList.remove("inactive");
                    }
                }
                else if (index == 0) {
                    rightArrow.classList.remove("inactive");

                    leftArrow.classList.add("inactive");
                }

                console.log(index);
            });
        }
    }
});